import { Star } from "lucide-react";

export const Stars = ({ value = 5, size = 16, interactive = false, onChange }) => (
  <div className="flex items-center gap-0.5" data-testid="stars">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        disabled={!interactive}
        onClick={() => interactive && onChange?.(n)}
        className={interactive ? "cursor-pointer transition-transform hover:scale-110" : "cursor-default"}
        aria-label={`${n} star`}
        data-testid={interactive ? `star-${n}` : undefined}
      >
        <Star
          style={{ width: size, height: size }}
          className={n <= value ? "fill-[#D4AF37] text-[#D4AF37]" : "fill-transparent text-[#5c5140]"}
        />
      </button>
    ))}
  </div>
);
